import React from "react";

import { PageContent, HubCardStack, TableSkeleton } from "../../components";
import { OutsideProcessingVendorTable } from "../../tables";
import { useVendorGetWorkOrders } from "../../hooks";

import OutsideBar from "./OutsideBar.jsx";

const OutsidePageContent = ({ defaultLocation }) => {
  const { isLoading } = useVendorGetWorkOrders({ defaultLocation });

  return (
    <PageContent gap="15px" smallPadding>
      <HubCardStack height="100%" gap="15px">
        <OutsideBar />
        {isLoading ? (
          <TableSkeleton rows={16} headerHeight={32.5} rowHeight={35.33} />
        ) : (
          <OutsideProcessingVendorTable defaultLocation={defaultLocation} />
        )}
      </HubCardStack>
    </PageContent>
  );
};

export default OutsidePageContent;
